import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { LegalDocumentsLayout } from '../../components/LegalDocumentsLayout';
import { LegalDocumentsCommon } from '../../components/LegalDocumentsCommon';
import { LegalDocumentsCountryside } from '../../components/LegalDocumentsCountryside';
import { OFFER_CARD_PATH_REGEX } from '../../constants/regex';
import { trackLinkOnCardClick } from './tracking';

export const LegalDocumentsContainer: React.FC = () => {
  const showCountrysideRules = useSelector((state: IApplicationState) => state.showCountrysideRules);

  const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const href = event.currentTarget.href;

    if (OFFER_CARD_PATH_REGEX.test(window.location.pathname)) {
      trackLinkOnCardClick(href);

      return;
    }
  };

  return (
    <LegalDocumentsLayout>
      {showCountrysideRules && <LegalDocumentsCountryside onLinkClick={handleLinkClick} />}
      {!showCountrysideRules && <LegalDocumentsCommon onLinkClick={handleLinkClick} />}
    </LegalDocumentsLayout>
  );
};
